<style>
.slide-transition {
  transition: all 0.4s ease;
}
.slide-enter {
  transform: translate3d(-100%, 0, 0);
}
.slide-leave {
  transform: translate3d(-100%, 0, 0);
}
.router-transition-enter-active {
  transition: all 0.3s ease;
}
.router-transition-leave-active {
  transition: all 0.5s ease;
}
.router-transition-enter,
.router-transition-leave-active {
  transform: translateX(-20px);
  opacity: 0;
}
</style>
<template>
  <div class="main" :class="{ hasNavbar: isShowNav, hasAppTip: isShowAppTip }">
    <app-tip v-show="isShowAppTip"></app-tip>
    <transition name="router-transition" mode="out-in">
      <keep-alive :max="2">
        <router-view ref="keepAlive"></router-view>
      </keep-alive>
    </transition>

    <nav-bar v-if="isShowNav"></nav-bar>
  </div>
</template>

<script>
import header from './components/header.vue'
import navBar from './components/nav-bar.vue'
import appTip from './components/app-tip'
import { mapState } from 'vuex'
import { Toast } from 'mint-ui'
import op from 'object-path'
import isQiYeGou from './mixins/qiyegou/qiyegou'

import Service from './service/city'
import { getUrlparam } from './util/function'

const env = process.env || 'development'
export default {
  mixins: [isQiYeGou],
  data() {
    return {
      test: 'hehe',
    }
  },
  computed: {
    ...mapState({
      errorAppear: (state) => state.errorAppear,
      errorMsg: (state) => state.errorMsg,
    }),
    isShowAppTip(v) {
      return !!v.$store.state.rc.app.showAppTip
    },
    isShowNav() {
      const needShowNavs = ['home', 'homeCategory', 'enterprise', 'center']
      if (this.isInQYGChannel) {
        needShowNavs.push('globalMain')
        needShowNavs.push('globalCategory')
      }
      return needShowNavs.findIndex((el) => el === this.$route.name) !== -1
    },
    isKeepAlive() {
      return !!op(this.$route).get('meta.isKeepAlive')
    },
  },
  watch: {
    errorAppear() {
      if (this.errorMsg === '数据为空') {
        return
      }
      if (this.errorMsg === '查询券信息失败') {
        return
      }
      if (this.errorMsg === '该券已过期') {
        return
      }
      Toast({
        message: this.errorMsg,
        position: 'bottom',
        duration: 3000,
      })
    },
    $route(to, from) {
      if (to.name === from.name) {
        return
      }
      // 嵌套路由 暂不销毁
      if (to.matched.length == from.matched.length) {
        if (to.matched[0] == from.matched[0]) {
          return
        }
      }
      const keepAliveWhiteList = ['examineItem', 'itemDetail']
      const fromPathBackList = ['preorder']
      // debugger

      // 如果不是前往detail页，就把isKeepAlive删掉
      if (
        (this.$refs.keepAlive && !keepAliveWhiteList.includes(to.name)) ||
        fromPathBackList.includes(from.name)
      ) {
        this.$refs.keepAlive.$destroy()
      }
    },
  },
  components: {
    'my-header': header,
    'nav-bar': navBar,
    'app-tip': appTip,
  },
  mounted() {
    // 通知 prerender-spa-plugin 可以渲染了
    document.dispatchEvent(new Event('render-event'))
    this.initVconsole()
  },
  methods: {
    initVconsole() {
      // 在地址栏输入 ?vConsole=1 即可唤醒 vConsole 工具
      let m = getUrlparam('vConsole')
      // if(m === '1' && process.env !== 'production'){
      if (m === '1') {
        import('eruda').then((Eruda) => {
          console.log(Eruda)
          // new VConsole.default();
          Eruda.default.init()
        })
      }
    },
  },
}
</script>
<style lang="less">
.hasNavbar {
  margin-bottom: 49px;
}
</style>
